export default {"src":"/_next/static/media/us.007ac741.svg","height":93,"width":149,"blurWidth":0,"blurHeight":0};